import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { calcPercent } from './util';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import SmallProgressBar from './SmallProgressBar';

type Props = {
  completedPercent: number;
  supportedPercent: number;
};
const colors = {
  primary: {
    met: '#51A486',
    notMet: '#EA031F'
  },
  secondary: {
    met: '#FFC20E',
    notMet: '#919191'
  }
};

const SmallBarChart: React.FC<Props> = ({ completedPercent, supportedPercent }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flex={1} flexDirection="column">
      {
        <SmallProgressBar
          metColor={colors.primary.met}
          notMetColor={colors.primary.notMet}
          metDescription={<Description text="Skills Met" />}
          MetEndAdornment={
            <CheckCircleIcon
              fontSize="small"
              color="inherit"
              classes={{ root: `${classes.icon} ${classes.check}` }}
            />
          }
          notMetDescription={<Description text="Skills Not Met" />}
          NotMetEndAdornment={
            <CancelIcon fontSize="small" color="error" classes={{ root: classes.icon }} />
          }
          title="Completed Lessons"
          currentPercent={Math.round(completedPercent)}
        />
      }

      <Box width={`${calcPercent(completedPercent, 100)}%`}>
        {completedPercent > 0 && (
          <SmallProgressBar
            currentPercent={Math.round(supportedPercent)}
            metColor={colors.secondary.met}
            notMetColor={colors.secondary.notMet}
            metDescription={<Description text="Needed Support Path" />}
            MetEndAdornment={
              <FiberManualRecordIcon
                style={{
                  fontSize: 12,
                  alignSelf: 'center',
                  color: '#FFC20E'
                }}
              />
            }
            notMetDescription={<Description text="Did not need Support Path" />}
            title="Supports Provided"
          />
        )}
      </Box>
    </Box>
  );
};

const Description = ({ text }: { text: string }) => (
  <Typography variant="h6" style={{ fontWeight: 400, lineHeight: '1.5rem', marginLeft: 5 }}>
    {text}
  </Typography>
);

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 12,
    alignSelf: 'center',
    marginLeft: 4
  },
  check: {
    color: '#51A486'
  }
}));

export default SmallBarChart;
